import './App.css';
import HomePage from './HomePage';
import ContributePage from './ContributePage';
import ShopPage from './ShopPage';
import ProductPage from './ProductPage';

function App() {
  const path = window.location.pathname;
  const isContributePage = path.startsWith('/contribuer');
  const isShopPage = path.startsWith('/boutique');
  const isProductPage = path.startsWith('/produit');

  return (
    <div className="App">
      {isContributePage ? (
        <ContributePage />
      ) : isShopPage ? (
        <ShopPage />
      ) : isProductPage ? (
        <ProductPage />
      ) : (
        <HomePage />
      )}
    </div>
  );
}

export default App;
